export enum CampaignStatusEnum {
  DRAFT = "DRAFT",
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  WAITING = "WAITING",
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
  CANCELED = "CANCELED",
  CANCELED_BY_FRANCHISE = "CANCELED_BY_FRANCHISE",
  CANCELED_BY_ADMIN = "CANCELED_BY_ADMIN",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  PENDING_FRANCHISE_APPROVAL = "PENDING_FRANCHISE_APPROVAL",
}

export const CampaignStatusEnumMapping: Record<CampaignStatusEnum, string> = {
  [CampaignStatusEnum.WAITING]: "enumMapping.campaigns.status.filter.WAITING",
  [CampaignStatusEnum.ONGOING]: "enumMapping.campaigns.status.filter.ONGOING",
  [CampaignStatusEnum.FINISHED]: "enumMapping.campaigns.status.filter.FINISHED",
  [CampaignStatusEnum.DRAFT]: "enumMapping.campaigns.status.filter.DRAFT",
  [CampaignStatusEnum.AWAITING_PAYMENT]:
    "enumMapping.campaigns.status.filter.AWAITING_PAYMENT",
  [CampaignStatusEnum.AWAITING_APPROVAL]:
    "enumMapping.campaigns.status.filter.AWAITING_APPROVAL",
  [CampaignStatusEnum.CANCELED]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.CANCELED_BY_FRANCHISE]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.CANCELED_BY_ADMIN]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.PENDING_CONFIRMATION]:
    "enumMapping.campaigns.status.filter.PENDING_CONFIRMATION",
  [CampaignStatusEnum.PENDING_FRANCHISE_APPROVAL]:
    "enumMapping.campaigns.status.filter.PENDING_FRANCHISE_APPROVAL",
};

export const CommandeStatusForADEnumMapping: Record<
  CampaignStatusEnum,
  string
> = {
  [CampaignStatusEnum.WAITING]: "enumMapping.campaigns.status.filter.PAID",
  [CampaignStatusEnum.ONGOING]: "enumMapping.campaigns.status.filter.ONGOING",
  [CampaignStatusEnum.FINISHED]: "enumMapping.campaigns.status.filter.FINISHED",
  [CampaignStatusEnum.DRAFT]: "enumMapping.campaigns.status.filter.ORDER",
  [CampaignStatusEnum.AWAITING_PAYMENT]:
    "enumMapping.campaigns.status.filter.AWAITING_PAYMENT",
  [CampaignStatusEnum.AWAITING_APPROVAL]:
    "enumMapping.campaigns.status.filter.AWAITING_APPROVAL",
  [CampaignStatusEnum.CANCELED]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.CANCELED_BY_FRANCHISE]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.CANCELED_BY_ADMIN]: "enumMapping.campaigns.status.filter.CANCELED",
  [CampaignStatusEnum.PENDING_CONFIRMATION]:
    "enumMapping.campaigns.status.filter.PENDING_CONFIRMATION",
  [CampaignStatusEnum.PENDING_FRANCHISE_APPROVAL]:
    "enumMapping.campaigns.status.filter.PENDING_FRANCHISE_APPROVAL",
};

export interface CampaignStatusInterface {
  id: CampaignStatusEnum;
  value: string;
}
